import { useMutation } from "@tanstack/react-query";
import {
  FeeScheduleControllerApi,
  GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum,
  GetFeeScheduleAmountByTypeFeeScheduleTypeEnum,
} from "../../services";
import { getConfigObject, getXtenantId } from "../../utils/utils";

export interface GetAmountFromFeeScheduleByProviderProps {
  providerId: string;
  codeId: string;
  feeScheduleType: GetFeeScheduleAmountByTypeFeeScheduleTypeEnum;
}

export const useGetAmountFromFeeScheduleByProvider = () =>
  useMutation({
    mutationFn: async ({
      providerId,
      codeId,
      feeScheduleType,
    }: GetAmountFromFeeScheduleByProviderProps) =>
      new FeeScheduleControllerApi(getConfigObject()).getFeeScheduleAmountByType(
        providerId,
        codeId,
        feeScheduleType,
        getXtenantId()
      ),
  });

export interface GetAmountFromFeeScheduleByPayerProps {
  payerId: string;
  codeId: string;
  feeScheduleType: GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum;
}

export const useGetAmountFromFeeScheduleByPayer = () =>
  useMutation({
    mutationFn: async ({
      payerId,
      codeId,
      feeScheduleType,
    }: GetAmountFromFeeScheduleByPayerProps) =>
      new FeeScheduleControllerApi(
        getConfigObject()
      ).getFeeScheduleAmountByPayerAndType(
        payerId,
        codeId,
        feeScheduleType,
        getXtenantId()
      ),
  });
